import React from "react";

export default function StatCard({ label, value, sub }) {
  return (
    <div className="bg-white border border-[#E8ECE9] p-5" data-testid={`stat-${label.toLowerCase().replace(/ /g,'-')}`}>
      <div className="text-[10px] uppercase tracking-[0.15em] text-[#7D8C85]">{label}</div>
      <div className="font-serif text-3xl text-[#11211A] mt-2 leading-none">{value ?? 0}</div>
      {sub && <div className="text-xs text-[#7D8C85] mt-2">{sub}</div>}
    </div>
  );
}
